import {VNode} from 'snabbdom';

type TSXFunction = (...a: any[]) => VNode;
type TSXRenderer = (tsxFunctionName: string, params: Obj) => VNode;

export function generateTsxRenderer(tsxFunctions: {[name: string]: TSXFunction}): TSXRenderer {
  return (tsxFunctionName: string, params: Obj) => {
    if (tsxFunctionName in tsxFunctions) {
      return tsxFunctions[tsxFunctionName](params);
    }
    return null;
  };
}

/* Example
 *
 *  // index.ts
 * 		import {
 *    	NoDataHero,
 * 			SensitiveDataHero,
 * 		} from 'common/widgets/warning-hero/presets';
 *
 * 		helpers: {
 * 			renderTsx: generateTsxRenderer({NoDataHero, SensitiveDataHero})
 * 		}
 *
 *	// ./index.jade
 *
 * 	= $helpers.renderTsx(
 * 		`NoDataHero`,
 * 		{bodyText: `I am a text written in a .jade template`, reportName: `insights`})
 */
